import React from 'react'
import {Link} from 'gatsby'
import logo from "../../assets/images/logo.png"
import footerMap from "../../assets/images/footer-map.png"

const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-area bg-color">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget">
                            <a href="/" className="logo">
                                <img src={logo} alt="logo" />
                            </a>
                            <p>Distance learning can be exhausting for students and for instructors and counselors. Percorso provides guidance for learners and educators to support goal attainment, communication, and feedback. </p>

                            
                        </div>
                    </div>

                    <div className="col-lg-2 col-sm-6">
                        <div className="single-footer-widget pl-5">
                            <h3>Explore</h3>
                            
                            <ul className="footer-links-list">
                                <li>
                                    <Link to="/">
                                        Home
                                    </Link>
                                </li>
                                {/* <li>
                                    <Link to="/pricing">
                                        Pricing
                                    </Link>
                                </li> */}
                                <li>
                                    <Link to="/solutions">
                                        Solutions
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/features">
                                        Features
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>&nbsp;</h3>

                            <ul className="footer-links-list">
                                <li>
                                    <Link to="/contact">
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/faq">
                                        Support
                                    </Link>
                                </li>
                                <li>
                                    <Link to="https://percorso.app/Account/Login">
                                        Login
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>Address</h3>

                            <ul className="footer-contact-info">
                                <li>
                                    <i className='bx bx-map'></i> 
                                    1960 Case Parkway S Twinsburg, OH 44087

                                </li>
                                <li>
                                    <i className='bx bx-phone-call'></i>
                                    <a href="tel:+2342849788">+1 (234) 284 9788</a>
                                </li>
                                <li>
                                    <i className='bx bx-envelope'></i>
                                    <a href="mailto:info@percorsoapp.com">info@percorsoapp.com</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom-area">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <p><strong>Percorso App</strong></p>
                        </div>

                        
                    </div>
                </div>
            </div>
        </footer>
    );
}
/*<div className="col-lg-6 col-md-6">
                            <ul>
                                <li>
                                    <Link to="/privacy-policy">
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/terms-of-service">
                                        Terms & Conditions
                                    </Link>
                                </li>
                            </ul>
                        </div>*/
/*

<div className="footer-map">
    <img src={footerMap} alt="footer-logo" />
</div>

*/ 

export default Footer;